import {Trans} from 'react-i18next'
import messages from '../../../assets/messages'
import {Banner, BannerIcon, BannerTitle} from './MlmInfoBanner.styled'

/**
 * Static informational banner shown above the tree explaining how the hierarchical
 * PAMM offers structure is laid out. Takes no props.
 */
export const MlmInfoBanner = () => (
  <Banner>
    <BannerIcon />
    <p>
      <BannerTitle>
        <Trans {...messages.pammHierarchyBannerTitle} />
      </BannerTitle>{' '}
      <Trans {...messages.pammHierarchyBannerText} />
    </p>
  </Banner>
)
